<template>
    <div id="calendar">
        <div class="route-page-content breadcrumb-content">
            <SidebarChild
                :items="menuItems"
                :selected-item="currentPage"
                :focusActive="true"
                @selected="fnClicked"
                @clicked="fnClicked"
                className="calendar-menu"
            />
            <div class="page-content-wrapper">
                <AutomationList type="event" module="calendar" v-if="currentPage === 'automations'" />
                <a-spin :spinning="loading" style="width: 100%" v-else>
                    <div style="height: fit-content; margin-top: 55px">
                        <vc-date-picker v-model="dateRange" color="red" />
                        <CalendarList
                            :calendarList="calendarList"
                            :selectedCalendars="selectedCalendars"
                            @selectCalendar="selectCalendar"
                            @updateCalendarColor="updateCalendarColor"
                            @deleteCalendarEvents="deleteCalendarEvents"
                        />
                        <ReservationList />
                    </div>
                    <div class="container">
                        <FullCalendar :options="calendarOptions" ref="calendar" />
                        <CalendarEventListview
                            :events="events"
                            :group-by-date="true"
                            v-if="$route.params.type === 'l'"
                            :calendarList="calendarList"
                            style="margin-top: 10px"
                        />
                    </div>
                    <CreateEventModal
                        :eventDetail="eventDetail"
                        :selectedStartDate="selectedStartDate === '' ? new Date() : selectedStartDate"
                        :selectedEndDate="selectedEndDate === '' ? new Date() : selectedEndDate"
                        :calendarList="calendarList"
                        v-if="newEventModalVisible"
                        @close="newEventModalVisible = false"
                        @deleteEvent="deleteEventFunction($event)"
                        @editEvent="editEvent($event)"
                    />
                </a-spin>
            </div>
        </div>
    </div>
</template>
<!--  -->
<script>
import AppBreadCrumb from "../../../components/common/AppBreadCrumb.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import TaskDrawer from "./Component/TaskDrawer.vue";
import CreateEventModal from "./Component/CreateEventModal.vue";
import moment from "moment";
import momentTz from "moment-timezone";
import CalendarList from "./Component/CalendarList.vue";
import _ from "lodash";
import VueDatepickerLocal from "vue-datepicker-local";
import NoMessage from "../Mail/NoMessage.vue";
import AgentAvatar from "../../../components/common/AgentAvatar.vue";
import CalendarEventListview from "./Component/calendar-events/CalendarEventListview.vue";
import ReservationList from "./Component/ReservationList.vue";
import ReservationEventModal from "./Component/ReservationEventModal.vue";
import { PERMISSION_TYPES } from "../../../language/permissionTypes";
import SidebarChild from "../../../components/Sidebar/SidebarChild.vue";
import getCalendarMenuItems from "./Component/calendarMenuItems";
import AutomationList from "../Automation/pages/automations/AutomationList.vue";
import momentTimezonePlugin from "@fullcalendar/moment-timezone";

const log = log2("Calendar");
export default {
    name: "Calendar",
    components: {
        CalendarEventListview,
        NoMessage,
        AppBreadCrumb,
        FullCalendar,
        TaskDrawer,
        VueDatepickerLocal,
        CreateEventModal,
        CalendarList,
        AgentAvatar,
        ReservationList,
        ReservationEventModal,
        SidebarChild,
        AutomationList,
    },
    props: {
        defaultPage: {
            type: String,
            default: "calendar",
        },
    },
    data() {
        return {
            currentPage: this.defaultPage || "calendar",
            mountedCount: 0,
            calendarColor: "",
            newCalendarSummary: "",
            newCalendarDescription: "",
            calendars: [],
            activeKey: 1,
            dateRange: this.convertDateFromUrl(this.$route.params.date),
            isVisibleTaskDrawer: false,
            selectedStartDate: "",
            selectedEndDate: "",
            selectedTag: "event",
            newEventModalVisible: false,
            calendarOptions: {
                customButtons: {
                    // tasks: {
                    //     text: this.$t("calendar.tasks"),
                    //     click: this.getTasks,
                    // },
                    setting: {
                        text: this.$t("calendar.setting"),
                        click: this.goSettingPage,
                    },
                    landingPage: {
                        text: this.$t("calendar.reservationWebPage"),
                        click: this.gotoLandingPage,
                    },
                },
                selectable: true,
                plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin, momentTimezonePlugin],
                datesSet: this.dataSet,
                dateClick: this.handleDateClick,
                eventClick: this.eventClick,
                select: this.selectDateRange,
                viewClassNames: this.viewClassNames,
                viewDidMount: this.viewDidMount,
                viewWillUnmount: this.viewWillUnmount,
                initialView: "timeGridDay",
                initialDate: this.convertDateFromUrl(this.$route.params.date),
                eventColor: "green",
                headerToolbar: {
                    start: "prev,next today",
                    center: "title",
                    end: "dayGridMonth,timeGridWeek,timeGridDay,listMonth landingPage,setting",
                },
                buttonText: {
                    today: this.$t("calendar.today"),
                    month: this.$t("calendar.month"),
                    week: this.$t("calendar.week"),
                    day: this.$t("calendar.day"),
                    list: this.$t("calendar.list"),
                },
                events: [],
                eventMinHeight: 55,
                height: "auto",
                locale: "tr",
                timeZone: momentTz.tz.guess(),
            },
            fileLoading: 0,
            attachments: [],
            assetIds: [],
            eventDetail: {},
            selectedCalendars: [],
            calendarList: [],
            loading: false,
            calendarColors: [],
            calendarSettings: {},
            isTaskList: false,
            isShowTaskList: false,
            selectedEventId: this.$route.params.eventId ? this.$route.params.eventId : null,
            eventDates: [],
            events: [],
        };
    },
    computed: {
        menuItems() {
            return getCalendarMenuItems();
        },
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            users: (state) => state.user.users.data,
            newEvent: (state) => state.calendar.newEvent,
            updatedEvent: (state) => state.calendar.updatedEvent,
            deleteEvent: (state) => state.calendar.deleteEvent,
            newCalendar: (state) => state.calendar.newCalendar,
            connectSuccess: (state) => state.calendar.connectSuccess,
            isAllDeleteEvents: (state) => state.calendar.isAllDeleteEvents,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
            getCalendarEvents: "calendar/getCalendarEvents",
            getEventDetail: "calendar/getEventDetail",
            getCalendarList: "calendar/getCalendarList",
            setWindows: "app/setWindows",
            updateCalendarColorAction: "calendar/updateCalendarColor",
            getTaskListByDate: "tasks/getTaskListByDate",
            getCalendarSettings: "calendar/getCalendarSettings",
        }),
        ...mapMutations({}),
        convertArabicToEnglish(dateStr) {
            const arabicNumbers = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
            const englishNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
            return dateStr.replace(/[٠-٩]/g, (d) => englishNumbers[arabicNumbers.indexOf(d)]);
        },
        fnClicked(item) {
            log("fnClicked", item);
            if (item.key === "calendar") {
                this.type = "calendar";
                this.$router.push("/calendar/d/" + moment().format().split("T")[0]);
            } else if (item.key === "reservationBuilder") {
                this.$router.push(item.path);
            } else if (item.key === "automations") {
                this.$router.push(item.path);
            }
        },
        getDay(date) {
            return moment(date.start).format("dddd") + ", " + moment(date.start).format("MMM Do YY");
        },
        getDateEvents(date) {
            return this.events.filter((event) => event.start.split("T")[0] === date.start.split("T")[0]);
        },
        async getDetailAndModal(event) {
            this.newEventModalVisible = true;
            this.eventDetail = await this.getEventDetail(event._id);
            this.selectedTag = this.eventDetail.type;
        },
        getEventTime(event) {
            return moment(event.start).format("HH:mm") + " - " + moment(event.end).format("HH:mm");
        },
        async getTasks() {
            this.isShowTaskList = !this.isShowTaskList;
            this.loading = true;
            if (this.isShowTaskList) {
                console.log("this.calendarOptions.events", this.calendarOptions.events);
                this.calendarOptions.events = this.calendarOptions.events.filter((item) => item.type !== "task");
                this.loading = false;
                return;
            } else {
                const calendarEndDate = this.$refs.calendar.getApi().currentData.dateProfile.activeRange.end;
                const calendarStartDate = this.$refs.calendar.getApi().currentData.dateProfile.activeRange.start;
                const data = {
                    userId: this.user._id,
                    startDate: new moment(calendarStartDate).format(),
                    endDate: new moment(calendarEndDate).format(),
                };
                this.getTaskListByDate(data).then((res) => {
                    let isAllDay = false;
                    const takEvents = res.map((item) => {
                        const startDate = !!item.startDate
                            ? moment(item.startDate).format()
                            : moment(item.createdAt).format();
                        const endDate = !!item.endDate ? moment(item.endDate).format() : moment(startDate).format();
                        if (moment(endDate).diff(moment(startDate), "days") > 0) isAllDay = true;
                        return {
                            type: "task",
                            title: item.title,
                            id: item._id,
                            start: startDate,
                            end: endDate,
                            allDay: isAllDay,
                        };
                    });
                    this.calendarOptions.events = [...this.calendarOptions.events, ...takEvents];
                });
            }
            this.loading = false;
        },
        updateCalendarColor({ calendarId, color }) {
            this.loading = true;
            const payload = {
                color,
                calendarId,
            };
            this.updateCalendarColorAction({ userId: this.user._id, payload }).then((res) => {
                this.calendarOptions.events = this.calendarOptions.events.map((item) => {
                    if (item.calendarId === calendarId) {
                        item.color = color;
                    }
                    return item;
                });
                this.calendarList.find((item) => item._id === calendarId).color = color;
                this.loading = false;
            });
        },
        async selectCalendar(calendar) {
            if (this.selectedCalendars.includes(calendar._id)) {
                this.selectedCalendars = this.selectedCalendars.filter((item) => item !== calendar._id);
            } else {
                this.selectedCalendars.push(calendar._id);
            }
            await this.getCalendarEventList();
        },
        gotoLandingPage() {
            this.$router.push("/reservation/landing-page");
        },
        goSettingPage() {
            if (this.checkPermission(PERMISSION_TYPES["calendar.update"].tr.name)) {
                this.setWindows({
                    "calendar-settings": {
                        type: "calendar-settings",
                        title: this.$t("calendar.calendarSetting"),
                        payload: {
                            defaultCalendar: this.calendarList.find(
                                (item) => !!item.isDefault && item.userId._id === this.user._id
                            ),
                            isOpenClick: true,
                        },
                        size: "40vw",
                    },
                });
            } else {
                this.$message.error(this.$t("calendar.notAuthorized"));
            }
        },
        async deleteEventFunction(e) {
            if (e.deleteType !== "single") {
                await this.getCalendarEventList();
            } else this.calendarOptions.events = this.calendarOptions.events.filter((item) => item.id !== e.eventId);
            this.newEventModalVisible = false;
        },
        editEvent(event) {
            console.log("editEvent..", event);
            let start = event.start;
            let end = event.end;

            // All-day eventler için sadece tarih formatı kullan ve end date'e +1 gün ekle (FullCalendar exclusive end için)
            if (event.isAllDay && start && end) {
                start = moment(start).format("YYYY-MM-DD");
                end = moment(end).add(1, "day").format("YYYY-MM-DD");
            }

            this.calendarOptions.events = this.calendarOptions.events.filter((item) => {
                if (item.id === event.eventId) {
                    item.title = event.summary;
                    item.start = start;
                    item.end = end;
                    item.allDay = event.isAllDay;
                }
                return item;
            });
        },
        async viewDidMount(arg) {
            console.log("viewDidMount arg", arg);
            // const calendarStartDate = this.$refs.calendar.getApi().currentData.dateProfile.activeRange.start;
            // this.dateRange = moment(calendarStartDate).format().split("T")[0];
            // await this.getCalendarEventList();
        },
        async viewWillUnmount(arg) {
            console.log("viewWillUnmount arg", arg);
            // const calendarStartDate = this.$refs.calendar.getApi().currentData.dateProfile.activeRange.start;
            // this.dateRange = moment(calendarStartDate).format().split("T")[0];
            // await this.getCalendarEventList();
        },
        async viewClassNames(arg) {
            const type =
                arg.view.type === "dayGridMonth"
                    ? "m"
                    : arg.view.type === "timeGridWeek"
                    ? "w"
                    : arg.view.type === "timeGridDay"
                    ? "d"
                    : "l";

            if (this.mountedCount > 1) {
                const currentDate = moment(this.dateRange).format().split("T")[0];
                this.$router.replace(`/calendar/${type}/${currentDate}`);
            }
        },
        async dataSet(arg) {
            console.log("dataSet work", arg);
            this.mountedCount += 1;
            if (arg.view.type === "timeGridDay") {
                const style = document.createElement("style");
                style.textContent = `
                    .fc-day-today {
                        background-color: white !important;
                    }
                `;
                document.head.appendChild(style);
            } else {
                const style = document.createElement("style");
                style.textContent = `
                    .fc-day-today {
                        background-color: #fff9f2 !important;
                    }
                `;
                document.head.appendChild(style);
            }

            // Her görünüm değiştiğinde zaman dilimini kontrol edelim
            if (this.calendarSettings && this.calendarSettings.timezone) {
                const currentTimezone = this.$refs.calendar.getApi().getOption("timeZone");
                if (currentTimezone !== this.calendarSettings.timezone) {
                    console.log(
                        `Timezone uyumsuzluğu. Mevcut: ${currentTimezone}, Olması gereken: ${this.calendarSettings.timezone}`
                    );
                    this.$refs.calendar.getApi().setOption("timeZone", this.calendarSettings.timezone);
                }
            }

            //this.dateRange = moment(arg.start).format().split("T")[0];
            await this.getCalendarEventList();
        },
        async eventClick(arg) {
            const event = this.calendarOptions.events.find((item) => item.id === arg.event.id);
            if (event.type === "task") {
                this.addNewWindow({
                    type: "editor-task",
                    payload: {
                        taskId: arg.event.id,
                    },
                });
            } else {
                this.getEventDetail(arg.event.id).then((detail) => {
                    this.selectedTag = detail.type;
                    this.eventDetail = detail;
                    this.newEventModalVisible = true;
                });
            }
        },
        selectDateRange(arg) {
            this.selectedStartDate = arg.start;
            this.selectedEndDate = arg.end;
            this.newEventModalVisible = true;
            this.eventDetail = {};
        },
        handleDateClick(arg) {
            this.eventDetail = {};
            this.selectedTag = "event";
            this.selectedStartDate = arg.date;
            this.newEventModalVisible = true;
        },
        deleteCalendarEvents(calendarId) {
            this.calendarOptions.events = this.calendarOptions.events.filter((item) => item.calendarId !== calendarId);
        },
        async getCalendarEventList() {
            this.loading = true;
            const calendarEndDate = this.$refs.calendar.getApi().currentData.dateProfile.activeRange.end;
            const calendarStartDate = this.$refs.calendar.getApi().currentData.dateProfile.activeRange.start;
            const startDate = this.convertArabicToEnglish(moment(calendarStartDate).format("YYYY-MM-DD"));
            const endDate = this.convertArabicToEnglish(moment(calendarEndDate).format("YYYY-MM-DD"));
            const data = {
                calendarIds: this.selectedCalendars,
                userId: this.user._id,
                startDate: startDate,
                endDate: endDate,
            };
            await this.getCalendarEvents(data).then((res) => {
                this.events = res;
                this.calendarOptions.events = res.map((event) => {
                    let start = event.start;
                    let end = event.end !== "" ? event.end : "";

                    // All-day eventler için sadece tarih formatı kullan ve end date'e +1 gün ekle (FullCalendar exclusive end için)
                    if (event.isAllDay && start && end) {
                        start = moment(start).format("YYYY-MM-DD");
                        end = moment(end).add(1, "day").format("YYYY-MM-DD");
                    }

                    return {
                        title: (event.type === "reservation" ? "+ " : "") + event.summary,
                        start: start,
                        end: end,
                        allDay: event.isAllDay,
                        id: event._id,
                        calendarId: event.calendarId,
                        color: this.calendarList.find((item) => item._id === event.calendarId)?.color,
                    };
                });
                this.loading = false;
            });
        },
        convertDateFromUrl(dateStr) {
            if (!dateStr) return moment().format().split("T")[0];
            const convertedDate = this.convertArabicToEnglish(dateStr);
            return moment(convertedDate).isValid() ? convertedDate : moment().format().split("T")[0];
        },
    },
    async mounted() {
        moment.locale(this.$i18n.locale);
        this.calendarOptions.locale = this.$i18n.locale;
        this.newEventModalVisible = this.$route.query.action;
        this.calendarOptions.initialView = ["m", "w", "d", "l"].includes(this.$route.params.type)
            ? this.$route.params.type === "d"
                ? "timeGridDay"
                : this.$route.params.type === "w"
                ? "timeGridWeek"
                : this.$route.params.type === "m"
                ? "dayGridMonth"
                : "listMonth"
            : "timeGridDay";

        this.calendarList = await this.getCalendarList({ userId: this.user._id, userName: this.user.name });
        console.log("this.calendarList", this.calendarList);
        this.selectedCalendars = this.calendarList
            .filter((item) => item.userId._id === this.user._id)
            .map((item) => item._id);

        await this.getCalendarSettings({ userId: this.user?._id }).then((settings) => {
            console.log("calendarSettings", settings);
            this.calendarSettings = settings;

            const userTimezone = settings && settings.timezone ? settings.timezone : momentTz.tz.guess();

            this.calendarOptions.timeZone = userTimezone;

            if (this.$refs.calendar && this.$refs.calendar.getApi()) {
                this.$refs.calendar.getApi().setOption("timeZone", userTimezone);
            }
        });
        await this.getCalendarEventList();

        if (this.selectedEventId) {
            this.getEventDetail(this.selectedEventId).then((detail) => {
                this.selectedTag = detail.type;
                this.eventDetail = detail;
                this.newEventModalVisible = true;
            });
        }

        const initialDate = this.convertDateFromUrl(this.$route.params.date);
        this.dateRange = initialDate;
        this.calendarOptions.initialDate = initialDate;

        // Fazladan butonları kaldır
        this.$nextTick(() => {
            const extraButtons = document.querySelectorAll(".fc--button");
            extraButtons.forEach((button) => {
                button.remove();
            });
        });

        // Timezone değişikliği dinleyici
        this.$root.$on("timezone-changed", async (data) => {
            if (data.userId === this.user._id) {
                console.log("Calendar: timezone changed", data.timezone);

                // Zaman dilimini güncelle
                this.calendarOptions.timeZone = data.timezone;

                // Takvim API'sini kullanarak zaman dilimini ayarla
                if (this.$refs.calendar && this.$refs.calendar.getApi()) {
                    this.$refs.calendar.getApi().setOption("timeZone", data.timezone);

                    // Takvimi yeniden render et
                    this.$refs.calendar.getApi().render();
                }

                // Takvimi yenile
                await this.getCalendarEventList();

                // Kalenderda geçerli tarihe git
                this.$refs.calendar.getApi().gotoDate(moment(this.dateRange).format());

                // CalendarSettings için de güncelleyelim
                if (!this.calendarSettings) this.calendarSettings = {};
                this.calendarSettings.timezone = data.timezone;
            }
        });
    },
    beforeDestroy() {
        // Event listener'ı temizle
        this.$root.$off("timezone-changed");
    },
    beforeMount() {
        if (!this.checkPermission(PERMISSION_TYPES["calendar.read"].tr.name)) {
            return this.$router.push("/denied");
        }
    },
    watch: {
        "$i18n.locale": {
            handler: function (newLocale, oldLocale) {
                this.calendarOptions.locale = newLocale;
                moment.locale(newLocale);
                this.calendarOptions.buttonText = {
                    today: this.$t("calendar.today"),
                    month: this.$t("calendar.month"),
                    week: this.$t("calendar.week"),
                    day: this.$t("calendar.day"),
                    list: this.$t("calendar.list"),
                };
                // this.calendarOptions.customButtons.tasks.text = this.$t("calendar.tasks");
                this.calendarOptions.customButtons.setting.text = this.$t("calendar.setting");
                this.calendarOptions.customButtons.landingPage.text = this.$t("calendar.reservationWebPage");
            },
        },
        calendarSettings: {
            handler: function (newSettings, oldSettings) {
                if (newSettings && oldSettings && newSettings.timezone !== oldSettings.timezone) {
                    console.log("Timezone changed, reloading calendar events...");
                    if (this.$refs.calendar && this.$refs.calendar.getApi()) {
                        this.$refs.calendar.getApi().setOption("timeZone", newSettings.timezone);
                        this.getCalendarEventList();
                    }
                }
            },
            deep: true,
        },
        selectedEventId(val) {
            this.getEventDetail(val).then((detail) => {
                this.selectedTag = detail.type;
                this.eventDetail = detail;
                this.newEventModalVisible = true;
            });
        },
        "$route.query.action"(val) {
            this.newEventModalVisible = val;
        },
        "$route.params.date": {
            handler(val) {
                if (val) {
                    const convertedDate = this.convertDateFromUrl(val);
                    this.dateRange = convertedDate;
                    if (this.$refs.calendar && this.$refs.calendar.getApi()) {
                        this.$refs.calendar.getApi().gotoDate(convertedDate);
                    }
                }
            },
            immediate: true,
        },
        dateRange(val) {
            this.$refs.calendar.getApi().gotoDate(moment(val).format());
        },
        updatedEvent(values) {
            console.log("updatedEvent..", values);
            values = _.isArray(values) ? values : [values];
            values.map((val) => {
                let start = val.start;
                let end = val.end !== "" ? val.end : "";

                // All-day eventler için sadece tarih formatı kullan ve end date'e +1 gün ekle (FullCalendar exclusive end için)
                if (val.isAllDay && start && end) {
                    start = moment(start).format("YYYY-MM-DD");
                    end = moment(end).add(1, "day").format("YYYY-MM-DD");
                }

                const newData = {
                    color: val.color
                        ? val.color
                        : this.calendarList.find((item) => item._id === val.calendarId)?.color || "#000000",
                    title: val.summary,
                    start: start,
                    end: end,
                    allDay: val.isAllDay,
                    id: val._id,
                };

                if (this.calendarOptions.events.find((event) => event.id === val._id)) {
                    this.calendarOptions.events = this.calendarOptions.events.map((event) => {
                        if (event.id === val._id) {
                            event = newData;
                        }
                        return event;
                    });
                }
                this.newEventModalVisible = false;
            });
        },
        newEvent(values) {
            console.log("newEvent...", { values });
            values = _.isArray(values) ? values : [values];
            values.map((val) => {
                let start = val.start;
                let end = val.end !== "" ? val.end : "";

                // All-day eventler için sadece tarih formatı kullan ve end date'e +1 gün ekle (FullCalendar exclusive end için)
                if (val.isAllDay && start && end) {
                    start = moment(start).format("YYYY-MM-DD");
                    end = moment(end).add(1, "day").format("YYYY-MM-DD");
                }

                const color = this.calendarList.find((item) => item._id === val.calendarId)?.color;
                const newData = {
                    color,
                    title: val.summary,
                    start: start,
                    end: end,
                    allDay: val.isAllDay,
                    id: val._id,
                };
                if (this.calendarOptions.events.find((event) => event.id === val._id)) {
                    this.calendarOptions.events = this.calendarOptions.events.map((event) => {
                        if (event.id === val._id) {
                            event = newData;
                        }
                        return event;
                    });
                } else {
                    this.calendarOptions.events = [...this.calendarOptions.events, newData];
                }
                this.newEventModalVisible = false;
            });
            //this.$message.success("Etkinlik başarıyla oluşturuldu");
        },
        deleteEvent(value) {
            if (this.calendarOptions.events.find((event) => event.id === value._id)) {
                this.calendarOptions.events = this.calendarOptions.events.filter((event) => event.id !== value._id);
            }
        },
        newCalendar(val) {
            if (val) {
                if (this.calendarList.find((item) => item._id === val._id)) {
                    this.calendarList = this.calendarList.map((item) => {
                        if (item._id === val._id) {
                            item = val;
                        }
                        return item;
                    });
                } else {
                    this.calendarList = [...this.calendarList, val];
                }
            }
        },
        async isAllDeleteEvents() {
            this.calendarList = await this.getCalendarList({ userId: this.user._id, userName: this.user.name });
            await this.getCalendarEventList();
        },
        async connectSuccess() {
            this.calendarList = await this.getCalendarList({ userId: this.user._id, userName: this.user.name });
            this.selectedCalendars = this.calendarList
                .filter((item) => item.userId._id === this.user._id)
                .map((item) => item._id);
            this.loading = true;
            this.setWindows({});
            setTimeout(() => {
                this.getCalendarEventList();
            }, 3000);
        },
        defaultPage(val) {
            this.currentPage = val;
        },
    },
};
</script>

<style lang="scss">
#calendar {
    width: 100%;
    
    .route-page-content {
        height: 100% !important;
    }

    .ant-spin-container {
        display: flex;
        justify-content: space-around;
        margin: 0 20px;
    }

    .info {
        #avatar-placeholder {
            width: 30px !important;
            height: 30px !important;
        }
    }

    .other-users {
        #avatar-placeholder {
            width: 25px !important;
            height: 25px !important;
        }
    }

    .fc-tasks-button {
        display: none !important;
    }

    .fc .fc-list-table {
        display: none !important;
    }

    .fc .fc-daygrid-day-frame {
        max-height: 100px;
        min-height: 100px;
        flex-wrap: wrap;
        position: relative;
        display: flex;
        overflow-x: hidden;
    }

    .calendar-date-selected {
        background-color: #dadada !important;
    }

    .calendar-week {
        color: #000000 !important;
    }

    .fc .fc-toolbar {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        padding: 20px 0;
        margin-bottom: 20px;
        align-items: center;
    }

    .fc .fc-toolbar-title {
        font-size: 1.5rem;
        font-weight: 600;
        color: #333333;
        margin: 0;
    }

    .fc .fc-toolbar-chunk {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
    }

    .fc .fc-button {
        padding: 8px 16px !important;
        border-radius: 6px !important;
        border: 1px solid #d1d5db !important;
        background-color: transparent !important;
        color: #374151 !important;
        font-weight: 400 !important;
        font-size: 14px !important;
        transition: all 0.2s ease !important;
        text-transform: none !important;
        box-shadow: none !important;
    }

    .fc .fc-button:hover {
        background-color: #f9fafb !important;
        border-color: #9ca3af !important;
    }

    .fc .fc-button:active,
    .fc .fc-button-active {
        background-color: #374151 !important;
        color: #ffffff !important;
        border-color: #374151 !important;
    }

    .fc .fc-button:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }

    .fc .fc-prev-button,
    .fc .fc-next-button {
        padding: 8px 12px !important;
        min-width: auto !important;
    }

    .fc .fc-button-group {
        display: flex;
        gap: 0;
    }

    .fc .fc-button-group .fc-button {
        border-radius: 0 !important;
        margin: 0 !important;
        border-right: none !important;
    }

    .fc .fc-button-group .fc-button:last-child {
        border-right: 1px solid #d1d5db !important;
    }

    .fc .fc-button-group .fc-button:first-child {
        border-top-left-radius: 6px !important;
        border-bottom-left-radius: 6px !important;
    }

    .fc .fc-button-group .fc-button:last-child {
        border-top-right-radius: 6px !important;
        border-bottom-right-radius: 6px !important;
    }

    @media (max-width: 1024px) {
        .fc .fc-toolbar {
            flex-direction: column;
            align-items: stretch;
            gap: 15px;
        }

        .fc .fc-toolbar-chunk {
            justify-content: center;
            width: 100%;
        }

        .fc .fc-toolbar-title {
            text-align: center;
            font-size: 1.25rem;
        }
    }

    @media (max-width: 768px) {
        .fc .fc-toolbar {
            padding: 15px 0;
            gap: 12px;
        }

        .fc .fc-button {
            padding: 7px 12px !important;
            font-size: 13px !important;
        }

        .fc .fc-toolbar-title {
            font-size: 1.15rem;
        }
    }

    @media (max-width: 480px) {
        .fc .fc-button {
            padding: 6px 10px !important;
            font-size: 12px !important;
        }

        .fc .fc-toolbar-title {
            font-size: 1rem;
        }

        .fc .fc-prev-button,
        .fc .fc-next-button {
            padding: 6px 8px !important;
        }

        .fc .fc-toolbar-chunk {
            gap: 6px;
        }
    }
}
</style>

<style lang="scss" scoped>
input[type="checkbox"] {
    width: 15px;
    height: 22px;
    accent-color: green;
}

.fc-view-harness.fc-view-harness-active {
    max-height: 500px;
}

.save-color {
    background-color: #05183d;
    width: fit-content;
    padding: 5px;
    border-radius: 10px;
    color: white;
    font-size: 12px;
    margin-top: 10px;
    cursor: pointer;
}

.footer-action {
    display: flex;
    justify-content: end;
    width: 95%;

    .btn {
        background-color: rgb(66, 133, 244);
        color: white;
        padding: 5px;
        margin: 5px;
        border-radius: 10px;

        &.delete {
            background-color: #ff4d4f;
        }
    }
}

.add-calendar-title {
    font-size: 20px;
    font-weight: 600;
}

#calendar {
    background-color: #ffffff;

    .page-content-wrapper {
        height: 100%;
        padding: 20px;
        display: flex;
        justify-content: space-around;
        .page-automation-list {
            width: 100%;
        }
    }

    .events {
        border: 1px solid #d5d4d4;
        border-radius: 10px;
        padding: 20px;
        margin-top: 10px;
        background-color: white;

        .date {
            color: black;
            font-weight: 700;
            font-size: 16px;
            width: fit-content;
        }

        .event {
            display: flex;
            width: 100%;
            flex-direction: column;

            .event-content {
                display: flex;
                padding: 7px;

                &:hover {
                    background-color: #e3f2ff;
                    cursor: pointer;
                }
            }

            .time {
                margin-right: 10px;
                width: 100px;
            }

            .divider-content {
                width: 100%;
                display: flex;
                justify-content: end;

                .divider {
                    width: 92%;
                    border: 0.5px solid lightgrey;
                }
            }

            .infos {
                display: flex;
                justify-content: space-between;
                width: 100%;

                .info {
                    display: flex;

                    .image {
                        margin-right: 10px;
                    }

                    .detail {
                        display: flex;
                        flex-direction: column;

                        .summary-title {
                            font-size: 15px;
                            font-weight: 700;
                            color: black;
                        }
                    }

                    .description {
                    }
                }
            }

            .other-users {
                display: flex;
                align-items: end;
            }
        }
    }

    .container {
        width: 80%;
        margin: 0;
    }

    .actions {
        display: flex;
        flex-direction: column;
        margin-right: 20px;

        .setting {
            margin-bottom: 10px;
            cursor: pointer;
        }

        .task {
            cursor: pointer;
            color: #448aff;
        }
    }
}
</style>

<style lang="scss">
.calendar-menu {
    .sidebar-menu-item-text{
        max-width:unset !important;
        min-width:unset !important;
    }
}
</style>
